/**
 * Test/demo environment helpers.
 *
 * Demo companies (sandbox workspaces and the shared "TEST" company) all read
 * from a single pool of sample customers instead of owning their own copies.
 * Those rows are flagged `is_shared_demo`. Row-level security only exposes the
 * pool to demo companies, so the filter below is safe to use everywhere: a real
 * company simply never sees the shared rows.
 */
export const companyOrSharedDemo = (companyId: string) =>
  `company_id.eq.${companyId},is_shared_demo.eq.true`;

/** Query string flag that keeps a session inside the guided demo experience. */
export const DEMO_FLAG_KEY = "mowzi_demo_session";
